import { getPlayitApiV2Base } from "../helpers/playitApiConfig";

const environment = {
  production: false,
  apiUrl: getPlayitApiV2Base(),
  apiKey: ""
};
export default environment;
